
































import Vue from 'vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import getAssetPath from '@/helpers/assets';

export default Vue.extend({
  components: {
    pxButton,
  },
  data() {
    return {
      notFoundSrc: getAssetPath('erro-404.png'),
    };
  },
});
